import { AlertTriangle } from 'lucide-react';
import { supabaseConfig } from '../lib/supabase';

export function MissingConfiguration() {
  const missing = supabaseConfig.missingVariables.join(', ');

  return (
    <div className="min-h-screen bg-scale-dark flex items-center justify-center p-4">
      <div className="w-full max-w-xl rounded-lg border border-red-500/20 bg-scale-navy p-6 text-center shadow-xl">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-500/10">
          <AlertTriangle className="h-6 w-6 text-red-400" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-white">Onboarding is not configured</h1>
        <p className="mx-auto max-w-md text-sm leading-6 text-gray-300">
          The production build is missing required Supabase settings, so the client setup flow cannot safely start.
        </p>
        <div className="mt-5 rounded-md border border-white/10 bg-scale-dark/60 p-4 text-left">
          <p className="text-xs font-semibold uppercase tracking-wide text-red-300">Missing hosting variables</p>
          <p className="mt-2 break-words font-mono text-sm text-white">{missing || 'Unknown Supabase configuration'}</p>
        </div>
        <p className="mt-5 text-sm leading-6 text-gray-400">
          Add the variables in the hosting provider and redeploy. No customer data was submitted from this page.
        </p>
      </div>
    </div>
  );
}
